import store from 'store/store';

import { authSlice } from 'store/auth/slice';

export const handle401 = async () => {
  store.dispatch(authSlice.actions.setLoggedOut());
};
